import Gallery from "./gallery.container";

export default Gallery;
